import {Component, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-task-getResourceByMsisdn',
  templateUrl: './task-getResourceByMsisdn.component.html'
})
export class TaskGetResourceByMsisdnComponent {
  taskCarrierId:any;
  msisdn:any;
  resource:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
  }

  search() {
    var params:HttpParams = new HttpParams()
      .set("taskCarrierId", this.taskCarrierId)
      .set("msisdn", this.msisdn)
    ;

    this.http.get(`${this.env.e.url}/task/omni/findResourceByMsisdn`, {params:params}).subscribe(
      data => {
        this.resource = data;
      }, error => {
        this.alertService.warn("Could not find resource");
      }
    );
  }
}
